import parkingYardService from "../../../services/parkingYard.service";
import { readListItems, readPagination } from "../../../utils/listPagination";

export function parkingYardMapsUrl(yard) {
  const loc = String(yard?.mapsUrl || yard?.location || "").trim();
  if (/^https?:\/\//i.test(loc)) return loc;
  const lat = Number(yard?.latitude);
  const lng = Number(yard?.longitude);
  if (Number.isFinite(lat) && Number.isFinite(lng)) {
    return `https://www.google.com/maps?q=${lat},${lng}`;
  }
  const query = String(yard?.address || yard?.name || "").trim();
  if (!query) return "";
  return `https://www.google.com/maps?q=${encodeURIComponent(query)}`;
}

export function yardFromConfirmation(confirmation) {
  if (!confirmation?.parkingYardId && !confirmation?.parkingYardName) return null;
  return {
    id: confirmation.parkingYardId ? String(confirmation.parkingYardId) : "",
    name: confirmation.parkingYardName || "",
    address: confirmation.parkingYardAddress || "",
    area: confirmation.parkingYardArea || "",
    pincode: confirmation.parkingYardPincode || "",
    phone: confirmation.parkingYardPhone || "",
    ownerMobile: confirmation.parkingYardPhone || "",
    managerName: confirmation.parkingYardManagerName || "",
    managerPhone: confirmation.parkingYardManagerPhone || "",
    managerMobile: confirmation.parkingYardManagerPhone || "",
  };
}

export async function searchParkingYards({ query, page = 1, limit = 10 } = {}) {
  const res = await parkingYardService.search({
    q: query || undefined,
    page,
    limit,
  });
  const payload = res?.data || {};
  return {
    yards: readListItems(payload, ["yards", "items"]),
    pagination: readPagination(payload),
  };
}
